<template>
	<!-- [ Main Content ] start -->
	<div v-if="response" class="row">
		<div class="row" style="margin-bottom: 0; margin-top: 2rem">
			<div class="col-lg-7"></div>
			<div class="card col-lg-5">
				<div class="text-center">
					<div class="card-body d-flex" style="padding: 5px">
						<select
							@change.prevent="setPositionParams($event.target.value)"
							class="form-select"
							id="elective_position_id"
							required
						>
							<option value="">--Filter By Position--</option>
							<option
								v-for="position in positions"
								:value="JSON.stringify(position)"
								:key="'ep' + position.id"
							>
								{{ position.name }}
							</option>
						</select>
						<select
							@change.prevent="setSubmissionParams($event.target.value)"
							class="form-select"
							id="report_submission_id"
							required
						>
							<option value="">--Filter By Submission--</option>
							<option
								v-for="submission in submissions"
								:value="JSON.stringify(submission)"
								:key="'sm_' + submission.id"
							>
								{{ submission.title }}
							</option>
						</select>
					</div>
				</div>
			</div>
		</div>
		<div class="col-12">
			<h4 class="text-secondary text-center">
				<!-- Dashboard Showing Expenses Of The {{ position }} Election -->
				Dashboard Showing Election Expenses
				<template v-if="submission_type"> For {{ submission_type }}</template>
			</h4>
		</div>
		<!-- Zone statistics -->
		<template v-if="user_can_view_zonal_data">
			<div
				v-for="(party, index) in response.parties"
				:class="{
					'col-md-12': response.parties.length === 1,
					'col-md-6': response.parties.length === 2,
					'col-md-4': response.parties.length === 3,
					'col-md-3': response.parties.length >= 4,
				}"
				:key="party + response_index + index"
			>
				<div class="card">
					<div class="card-body text-center">
						<h5 class="m-t-10">
							<span :style="'color:' + response.colours[index]"
								>{{ party }} ELECTION ZONAL EXPENSES</span
							>
						</h5>
						<span style="font-size: 10px; font-weight: 700"
							>SOURCE: CAMPAIGN TRACKING</span
						>
						<div class="table-responsive">
							<table class="table">
								<thead></thead>
								<tbody style="border-bottom: 2px solid black">
									<tr
										v-for="(values, zone, index) in response.party_data[party]"
										:key="party + response_index + index"
									>
										<td>{{ zone }}</td>
										<td>{{ values.total_cost }}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<!-- <button
								class="btn btn-primary btn-sm btn-round"
								data-bs-toggle="modal"
								data-title="Operation"
								data-bs-target="#modal-report"
							>
								View Report
							</button> -->
					</div>
					<div :id="party"></div>
				</div>
			</div>
		</template>

		<!-- Expense chart -->
		<div class="col-xl-12">
			<div class="card table-card">
				<div class="card-body px-0 py-0">
					<div
						v-if="response && response.expenses"
						id="expenses-container"
						style="height: 400px"
					></div>
				</div>
			</div>
		</div>
	</div>
	<!-- [ Main Content ] end -->
</template>
<script>
import $ from "jquery";
import ApexCharts from "apexcharts";
import { mapGetters, mapActions } from "vuex";
import { userHasPermission } from "@/utils/permissions";

var Highcharts = require("highcharts");
require("highcharts/modules/exporting")(Highcharts);

export default {
	data() {
		return {
			response_index: 0,
			response: null,
			position: "Presidential",
			submission_type: "",
			form: {
				report_submission_id: null,
				elective_position_id: null,
				// elective_position_id: "1",
			},
		};
	},
	computed: {
		...mapGetters({
			positions: "settings/elective_positions",
			submissions: "settings/report_submission",
		}),
		user_can_view_zonal_data() {
			return userHasPermission("staff-zonal-data-view");
		},
	},
	methods: {
		...mapActions({
			getElectivePositions: "settings/getElectivePositions",
			getReportSubmission: "settings/getReportSubmission",
		}),

		plotCharts(id, color) {
			$(function () {
				var options = {
					chart: {
						type: "area",
						height: 50,
						sparkline: {
							enabled: true,
						},
					},
					dataLabels: {
						enabled: false,
					},
					colors: [color],
					fill: {
						type: "solid",
						opacity: 0.3,
					},
					markers: {
						size: 3,
						opacity: 0.9,
						colors: "#fff",
						strokeColor: color,
						strokeWidth: 2,
						hover: {
							size: 7,
						},
					},
					stroke: {
						curve: "straight",
						width: 3,
					},
					series: [
						{
							name: "series1",
							data: [
								25, 66, 41, 89, 63, 25, 44, 12, 36, 9, 54, 25, 66, 41, 89, 63,
								54, 25, 66, 41, 89,
							],
						},
					],
					tooltip: {
						fixed: {
							enabled: false,
						},
						x: {
							show: false,
						},
						y: {
							title: {
								formatter: function () {
									return "Operation ";
								},
							},
						},
						marker: {
							show: false,
						},
					},
				};
				var chart = new ApexCharts(document.querySelector("#" + id), options);
				chart.render();
			});
		},

		drawStaticCharts() {
			if (!this.response.parties.length) {
				return;
			}

			this.response.parties.forEach((party, index) => {
				this.plotCharts(party, this.response.colours[index]);
			});
		},

		plotExpensesChart() {
			if (!this.response || !Object.keys(this.response).length) {
				return;
			}

			// Destroy previous chart instance if it exists
			if (this.expensesChart) {
				this.expensesChart.destroy();
			}

			this.expensesChart = Highcharts.chart("expenses-container", {
				chart: {
					type: "column",
				},
				title: {
					// text: `${this.position} ELECTION EXPENSES CHANNELS & AMOUNT SPENT`,
					text: "ELECTION EXPENSES CHANNELS & AMOUNT SPENT",
				},
				subtitle: {
					text: "Source: CAMPAIGN TRACKING",
				},
				xAxis: {
					categories: this.response.expenses,
					crosshair: true,
				},
				yAxis: {
					title: {
						useHTML: true,
						text: "TOTAL AMOUNT",
					},
				},
				tooltip: {
					headerFormat:
						"<span style='font-size:10px'>{point.key}</span><table>",
					pointFormat:
						"<tr><td style='color:{series.color};padding:0'>{series.name}: </td>" +
						"<td style='padding:0'><b>{point.y:.1f}</b></td></tr>",
					footerFormat: "</table>",
					shared: true,
					useHTML: true,
				},
				plotOptions: {
					column: {
						pointPadding: 0.2,
						borderWidth: 0,
					},
				},
				series: this.response.expense_data,
			});
		},

		async getDashboardData() {
			try {
				// Clear previous response while loading
				// this.response = null;

				// Wait for the data to be fetched
				const response = await this.$store.dispatch(
					"dashboard/getDashboardData",
					this.form
				);

				// Update reactive data
				this.response = response;
				this.response_index++;

				// Wait for the next DOM update cycle
				await this.$nextTick();

				// Now render the chart
				this.drawStaticCharts();
				this.plotExpensesChart();
			} catch (error) {
				console.error("Error fetching dashboard data:", error);
			}
		},
		setSubmissionParams(submission) {
			if (submission) {
				let data = JSON.parse(submission);

				this.submission_type = data.title;
				this.form.report_submission_id = data.id;
			} else {
				this.submission_type = "";
				this.form.report_submission_id = "";
			}

			this.getDashboardData();
		},

		setPositionParams(position) {
			if (position) {
				let data = JSON.parse(position);

				this.position = data.name;
				this.form.elective_position_id = data.id;
			} else {
				this.position = "Presidential";
				this.form.elective_position_id = "";
			}

			this.getDashboardData();
		},
	},
	mounted() {
		this.getDashboardData();
		this.getElectivePositions();
		this.getReportSubmission();
	},
};
</script>
<style scoped>
.table td {
	padding: 0.5rem 0.75rem !important;
	text-align: left !important;
}
</style>
